import {useContext} from 'react';
import {HighlightContext} from 'store/Highlight';

function useHighlight() {
    return useContext(HighlightContext);
}

export default useHighlight;
